export default __webpack_public_path__ + "static/media/bandeira_fr.1900663f.png";